<template>
    <div class="paymentOptionsWrap">
        <div class="paymentOption sofort" @click="activate('sofort')" :class="{ active : active === 'sofort' }">
            <h4 class="title">{{'components/payment/payment-options.sofort-title' | trans }}</h4>
            <div class="imageWrap">
                <img src="/assets/img/sofort.png" alt="sofort">
            </div>
        </div>
        <div class="paymentOption creditCards" @click="activate('creditCards')" :class="{ active : active === 'creditCards' }">
            <h4 class="title">{{'components/payment/payment-options.pay-credit-card' | trans }}</h4>
            <div class="imageWrap">
                <img class="visa" src="/assets/img/visa.png" alt="visa">
                <img class="master" src="/assets/img/master.png" alt="master">
            </div>
        </div>
    </div>
</template>

<script>
	export default {
        props: {
            paymentOption: {
                type: String
            }
        },
        data() {
            return {
                active: this.paymentOption,
            }
        },
        methods: {
            activate: function (el) {
                this.active = el;
                this.$emit('setPaymentOption', this.active);
            }
        },
        watch: {

        },
		mounted() {

        },
		computed: {

		}
    }
</script>
